"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthorizeIntegrationModal = exports.createAuthorizeIntegrationUi = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var OAuthWindow_1 = __importDefault(require("@CommonFrontend/OAuth/OAuthWindow"));
var icons = __importStar(require("@qwilr/kaleidoscope/icons"));
var Types_1 = require("@CommonFrontendBackend/Account/Integrations/Types");
var ActionRequired_1 = require("CreatePageFlow/CreatePageComponents/ActionRequired");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var CreatePageBackground_1 = require("CreatePageApp/CreatePageBackground");
var ErrorCodes_1 = require("@CommonFrontendBackend/ErrorCodes/ErrorCodes");
var Utils_1 = require("@CommonFrontendBackend/Account/Integrations/Utils");
var IntegrationLinkGenerator_1 = require("@CommonFrontendBackend/Utils/IntegrationLinkGenerator");
var ASSETS_DIR = "/Assets/";
var c = (0, BemBuilder_1.default)("create-page-flow-integration-configuration");
var AuthorizeIntegrationSettings = (function (_super) {
    __extends(AuthorizeIntegrationSettings, _super);
    function AuthorizeIntegrationSettings() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.isLoading = false;
        _this.errorMessage = "";
        _this.showExternalUserLinkedError = false;
        _this.authorizeUrl = "";
        _this.authorizeIntegration = function (url) { return __awaiter(_this, void 0, Promise, function () {
            var e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        this.setAuthorizeUrl(url);
                        return [4, OAuthWindow_1.default.show(url)];
                    case 1:
                        _b.sent();
                        return [3, 3];
                    case 2:
                        e_1 = _b.sent();
                        if (e_1.statusCode === 500 && ((_a = e_1.additionalInfo) === null || _a === void 0 ? void 0 : _a.errorCode) === ErrorCodes_1.ServerErrorCode.ExternalUserIDAlreadyLinked) {
                            this.setShowExternalUserLinkedError(true);
                            throw e_1;
                        }
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        return _this;
    }
    AuthorizeIntegrationSettings.prototype.setShowExternalUserLinkedError = function (showExternalUserLinkedError) {
        this.showExternalUserLinkedError = showExternalUserLinkedError;
    };
    AuthorizeIntegrationSettings.prototype.setIntegrationState = function (integrationState) {
        this.integrationState = integrationState;
    };
    AuthorizeIntegrationSettings.prototype.setIsLoading = function (isLoading) {
        this.isLoading = isLoading;
    };
    AuthorizeIntegrationSettings.prototype.setErrorMessage = function (errorMessage) {
        this.errorMessage = errorMessage;
    };
    AuthorizeIntegrationSettings.prototype.setAuthorizeUrl = function (url) {
        this.authorizeUrl = url;
    };
    AuthorizeIntegrationSettings.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, apiService, integrationName, integrationState, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, apiService = _a.apiService, integrationName = _a.integrationName;
                        this.setIsLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4, apiService.verifyIntegration(integrationName)];
                    case 2:
                        integrationState = _b.sent();
                        this.setIntegrationState(integrationState);
                        return [3, 5];
                    case 3:
                        e_2 = _b.sent();
                        this.setErrorMessage("Something went wrong. Please try again later or contact support.");
                        return [2];
                    case 4:
                        this.setIsLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    AuthorizeIntegrationSettings.prototype.render = function () {
        var _this = this;
        if (this.isLoading) {
            return (react_1.default.createElement("div", { className: c() },
                react_1.default.createElement(kaleidoscope_1.Spinner, { className: c("spinner"), size: kaleidoscope_1.SpinnerSize.Large, primary: true })));
        }
        else if (this.integrationState) {
            return (react_1.default.createElement("div", { className: c() },
                this.showExternalUserLinkedError && (react_1.default.createElement("div", { className: c("error-overlay") },
                    react_1.default.createElement("div", { className: c("error-overlay-inner") },
                        react_1.default.createElement("div", { className: "space-stack-m" },
                            react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", secondary: true }, "User already linked")),
                        react_1.default.createElement("div", { className: "space-stack-l" },
                            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", secondary: true }, (0, Utils_1.getRelinkExternalUserNotAllowedMessage)(this.integrationState.integration.displayName))),
                        react_1.default.createElement(kaleidoscope_1.Button, { className: c("error-overlay-button"), onClick: function () { return _this.setShowExternalUserLinkedError(false); } }, "Ok")))),
                react_1.default.createElement("div", { className: c("left-panel") }, this.renderAction(this.integrationState)),
                react_1.default.createElement("div", { className: c("right-panel") }, this.renderIcons(this.integrationState))));
        }
        else if (this.errorMessage) {
            return (react_1.default.createElement("div", { className: c() },
                react_1.default.createElement(kaleidoscope_1.Alert, { className: c("error"), alertType: kaleidoscope_1.AlertType.Error, heading: "Error" }, this.errorMessage)));
        }
        else {
            return null;
        }
    };
    AuthorizeIntegrationSettings.prototype.renderIcons = function (integrationState) {
        var integration = integrationState.integration;
        var images = {
            qwilr: "".concat(ASSETS_DIR, "Images/createPage/qwilrLogoLight.svg"),
            arrows: "".concat(ASSETS_DIR, "Images/createPage/arrows.svg"),
        };
        var Icon = integration.icon && icons[integration.icon];
        return (react_1.default.createElement("div", { className: c("images") },
            react_1.default.createElement("img", { className: c("qwilr-logo"), src: images.qwilr, alt: "qwilr logo placeholder" }),
            react_1.default.createElement("img", { className: c("arrows"), src: images.arrows, alt: "integration arrows placeholder" }),
            Icon && react_1.default.createElement(Icon, { className: c("integration-logo"), size: icons.IconSize.Large })));
    };
    AuthorizeIntegrationSettings.prototype.renderAction = function (integrationState) {
        var _this = this;
        var integration = integrationState.integration;
        var integrationInternalName = this.props.integrationName;
        var learnMoreLink = (0, IntegrationLinkGenerator_1.returnLearnMoreLink)(integrationInternalName);
        switch (integrationState.status) {
            case Types_1.TokenIntegrationVerificationStatus.ENABLE_INTEGRATION:
                return (react_1.default.createElement(ActionRequired_1.ActionRequired, { action: "Enable integration", message: "To connect Qwilr to ".concat(integration.displayName, ", you\u2019ll need to enable the integration in your Qwilr account settings."), buttonText: "Go to Settings", onButtonClick: function () {
                        window.location.href = "#/settings/integrations";
                    }, learnMoreLink: learnMoreLink }));
            case Types_1.TokenIntegrationVerificationStatus.REQUEST_TO_ENABLE_INTEGRATION:
                return (react_1.default.createElement(ActionRequired_1.ActionRequired, { action: "Enable integration", message: "To connect Qwilr to ".concat(integration.displayName, ", you\u2019ll need to enable the integration, but you don\u2019t have the right user permissions to do that. Talk to your account admin ").concat(integrationState.adminUserName, ", about getting the integration enabled."), learnMoreLink: learnMoreLink }));
            default:
                return (react_1.default.createElement(ActionRequired_1.ActionRequired, { action: "Authorize", message: "We need to let ".concat(integration.displayName, " know it can trust Qwilr to act on your behalf."), buttonText: "Authorize qwilr", onButtonClick: function () { return _this.authorizeIntegration(integrationState.authorizeUrl); }, learnMoreLink: learnMoreLink, successMessage: "You have successfully authorized Qwilr. You can now close this tab." }));
        }
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AuthorizeIntegrationSettings.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AuthorizeIntegrationSettings.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof Types_1.TokenIntegrationVerificationResult !== "undefined" && Types_1.TokenIntegrationVerificationResult) === "function" ? _a : Object)
    ], AuthorizeIntegrationSettings.prototype, "integrationState", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AuthorizeIntegrationSettings.prototype, "showExternalUserLinkedError", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AuthorizeIntegrationSettings.prototype, "authorizeUrl", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AuthorizeIntegrationSettings.prototype, "setShowExternalUserLinkedError", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof Types_1.TokenIntegrationVerificationResult !== "undefined" && Types_1.TokenIntegrationVerificationResult) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], AuthorizeIntegrationSettings.prototype, "setIntegrationState", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AuthorizeIntegrationSettings.prototype, "setIsLoading", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AuthorizeIntegrationSettings.prototype, "setErrorMessage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AuthorizeIntegrationSettings.prototype, "setAuthorizeUrl", null);
    AuthorizeIntegrationSettings = __decorate([
        mobx_react_1.observer
    ], AuthorizeIntegrationSettings);
    return AuthorizeIntegrationSettings;
}(react_1.default.Component));
var createAuthorizeIntegrationUi = function () {
    return react_1.default.createElement(CreatePageBackground_1.CreatePageAppBackground, null);
};
exports.createAuthorizeIntegrationUi = createAuthorizeIntegrationUi;
var createAuthorizeIntegrationModal = function (integrationName, apiService) {
    return react_1.default.createElement(AuthorizeIntegrationSettings, { integrationName: integrationName, apiService: apiService });
};
exports.createAuthorizeIntegrationModal = createAuthorizeIntegrationModal;
